import { ethers } from 'ethers';

const CONTRACT_ADDRESS = "0x75a05f185E2EdA5e4DD9E1c878D598490Ca9A6Dc";
const CONTRACT_ABI = [
    "function transactionFee() public view returns (uint256)",
    "function mint(address referrer) external payable",
    "function balanceOf(address owner) public view returns (uint256)",
    "function getReferrer(address user) external view returns (address)",
    "function getReferralCount(address user) external view returns (uint256)"
];

export const mintNFT = async (referrerAddress = null) => {
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

        const fee = await contract.transactionFee();
        console.log('Transaction fee:', ethers.utils.formatEther(fee), 'BNB');
        
        const tx = await contract.mint(
            referrerAddress || ethers.constants.AddressZero,
            { 
                value: fee,
                gasLimit: 300000 
            }
        );
        
        console.log('Transaction sent:', tx.hash);
        const receipt = await tx.wait();
        console.log('Transaction confirmed:', receipt);
        
        return { success: receipt.status === 1 };
    } catch (error) {
        console.error("Mint failed:", error);
        throw error;
    }
};

export const checkUserStatus = async (address) => {
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, provider);

        const [balance, referrer, referralCount] = await Promise.all([
            contract.balanceOf(address),
            contract.getReferrer(address),
            contract.getReferralCount(address)
        ]);

        return {
            is_checked_in: balance.gt(0),
            referrer_address: referrer,
            referral_count: referralCount.toNumber()
        };
    } catch (error) {
        console.error("Status check failed:", error);
        throw error;
    }
}; 